import "./help.css";
import PageSeo from "../../components/seo/PageSeo";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

/* FAQ — design "Signal" 4f */

const FAQ = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(0);

  const items = [
    {
      q: t("faq.questions.question1"),
      a: (
        <>
          {t("faq.questions.answer1")}
          <ol>
            <li>{t("faq.questions.step1")}</li>
            <li>{t("faq.questions.step2")}</li>
            <li>{t("faq.questions.step3")}</li>
            <li>{t("faq.questions.step4")}</li>
          </ol>
        </>
      ),
    },
    {
      q: t("faq.questions.question2"),
      a: (
        <>
          {t("faq.questions.answer2")}
          <ol>
            <li>{t("faq.questions.step11")}</li>
            <li>{t("faq.questions.step22")}</li>
            <li>{t("faq.questions.step33")}</li>
          </ol>
        </>
      ),
    },
    { q: t("faq.questions.question3"), a: t("faq.questions.answer3") },
    {
      q: t("faq.questions.question4"),
      a: <span dangerouslySetInnerHTML={{ __html: t("faq.questions.answer4") }} />,
    },
    { q: t("faq.questions.question5"), a: t("faq.questions.answer5") },
    { q: t("faq.questions.question6"), a: t("faq.questions.answer6") },
    { q: t("faq.questions.question7"), a: t("faq.questions.answer7") },
    { q: t("faq.questions.question8"), a: t("faq.questions.answer8") },
    { q: t("faq.questions.question9"), a: t("faq.questions.answer9") },
  ];

  return (
    <>
      <PageSeo path="/help" />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${t("faq.title")}`}</title>
        <meta
          name="description"
          content="Free Virtual Phone Number - Frequently asked questions. Find answers to common questions about our SMS receiving service with virtual phone numbers. Learn how to use temporary numbers for verification, troubleshoot delivery issues, and contact our support team."
        />
        <meta name="author" content="2FASMS" />
        <meta name="robots" content="index, follow" data-react-helmet="true" />
      </Helmet>

      <div className="sg-page" style={{ maxWidth: 760 }}>
        <div className="sg-panel" style={{ padding: 22 }}>
          <h1 className="sg-h1" style={{ fontSize: 24, marginBottom: 6 }}>
            {t("faq.title")}
          </h1>
          <p className="sg-sub" style={{ marginBottom: 16 }}>
            {t("faq.sub_title")}{" "}
            <a
              href="https://telegram.me/twofasms"
              target="_blank"
              rel="noreferrer"
              style={{ color: "var(--color-primary)", fontWeight: 600, textDecoration: "none" }}
            >
              {t("signal.faq-contact")}
            </a>{" "}
            {t("signal.faq-247")}
          </p>

          <div className="sg-acc">
            {items.map((item, i) => (
              <div key={i} className={`sg-acc__item ${open === i ? "is-open" : ""}`}>
                <button className="sg-acc__q" onClick={() => setOpen(open === i ? -1 : i)}>
                  <span>{item.q}</span>
                  <b>{open === i ? "−" : "+"}</b>
                </button>
                {open === i && <div className="sg-acc__a">{item.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
